<template>
    <div class="desktop-background">
        <div v-if="backgrounds.length > 0" class="desktop-background__list">
            <the-background-item
                v-for="(bg, index) in backgrounds"
                :key="bg.id"
                :selected="bg.used === 1"
                :removable="bg.used === 0"
                :background="bg.pictureUrl"
                @remove="onRemove(bg, index)"
                @click="select(bg)"
            />
        </div>

        <p class="grey99">最多能上传 4 张</p>
    </div>
</template>

<script>
import TheBackgroundItem from '@/components/desk-header/components/configs/components/the-background-item';
import { showError } from '../../../../../../utils/message';

export default {
    name: 'TheDesktopBackground',

    components: { TheBackgroundItem },

    props: {
        /**
         * @type {DesktopPictureConfig['background']}
         */
        backgrounds: {
            type: Array,
            default: () => []
        },

        removeMethod: {
            type: Function,
            default: () => Promise.resolve()
        },
        editMethod: {
            type: Function,
            default: () => Promise.resolve()
        }
    },

    computed: {
        vm: {
            get() {
                return this.backgrounds;
            },
            set(v) {
                this.$emit('update:backgrounds', v);
            }
        },

        background() {
            return this.$store.state.desk.background;
        }
    },

    methods: {
        /**
         * 选择背景图
         * @param image {string | number}
         */
        async select(image) {
            this.$store.commit('desk/setBackgroundImage', image.pictureUrl);
            try {
                await this.editMethod(image.id);
                this.backgrounds.forEach((item) => {
                    if (item.id === image.id) {
                        item.used = 1;
                    } else {
                        item.used = 0;
                    }
                });
            } catch (err) {
                return showError(err);
            }
        },

        /**
         * @param picture {DesktopPicture}
         * @param index
         */
        async onRemove(picture, index) {
            try {
                await this.removeMethod(picture.id);
            } catch (err) {
                return showError(err);
            }

            this.vm.splice(index, 1);

            // if (this.background === picture.pictureUrl) {
            //     this.select(0);
            // }
        }
    }
};
</script>

<style lang="scss" scoped>
.desktop-background {
    &__title {
        font-weight: bold;
        color: #333;
    }

    &__list {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 12px;
        margin-bottom: 12px;
    }
}
</style>
